import { UseAsyncReturn } from 'react-async-hook'

import { GoogleAutoCompleteResult } from '@mortgage-pos/types'

export const setAllFieldsToEmpty = (
  name: string,
  setFieldValue: (arg0: string, arg1: string) => void,
  addressFields: string[]
): void => {
  const addresses = [name, ...addressFields]
  addresses.forEach((field) => {
    setFieldValue(field, '')
  })
}

export const isCompleteAddress = (
  address: string,
  autoCompleteResults: UseAsyncReturn<GoogleAutoCompleteResult>
): boolean => {
  // If no existing auto-complete results, always return false
  if (autoCompleteResults.result?.status !== 'OK') {
    return false
  }

  const { predictions } = autoCompleteResults.result
  return predictions.some(({ description }) => description === address)
}

export const getQuestionDisplayName = (name: string): string => {
  switch (name) {
    case 'zipCode':
      return 'Zip Code'
    case 'apt':
      return 'Apt/Suite'
    default:
      return name[0].toUpperCase() + name.slice(1)
  }
}

export const addressFields: string[] = [
  'street',
  'apt',
  'city',
  'state',
  'zipCode',
]
